import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const setPushSubscriptionState = createAction(`${reduxKey}/SET_PUSH_SUBSCRIPTION_STATE`, (newState)=>({
        newState
    }));
export const togglePushSubscription = createAction(`${reduxKey}/TOGGLE_PUSH_SUBSCRIPTION`, ()=>({}));
export const registerPushSubscription = createAction(`${reduxKey}/REGISTER_PUSH_SUBSCRIPTION`, ()=>({}));
export const unregisterPushSubscription = createAction(`${reduxKey}/UNREGISTER_PUSH_SUBSCRIPTION`, ()=>({}));
export const initPushSubscriptions = createAction(`${reduxKey}/INIT_PUSH_SUBSCRIPTIONS`, ()=>({}));
export const displayPushNotificationsModal = createAction(`${reduxKey}/DISPLAY_PUSH_NOTIFICATIONS_MODAL`, ()=>({}));
export const initPushSubscriptionsSuccess = createAction(`${reduxKey}/INIT_PUSH_SUBSCRIPTIONS_SUCCESS`, (subscriptions)=>subscriptions);
export const updatePushSubscriptions = createAction(`${reduxKey}/UPDATE_PUSH_SUBSCRIPTIONS`, (subscriptions)=>subscriptions);
export const showPWABanner = createAction(`${reduxKey}/SHOW_PWA_BANNER`, ()=>({}));
export const dismissPWABanner = createAction(`${reduxKey}/DISMISS_PWA_BANNER`, ()=>({}));
export const savePWAInstallPrompt = createAction(`${reduxKey}/SAVE_PWA_INSTALL_PROMPT`, (event)=>event);

//# sourceMappingURL=actions.js.map